
export default {
  name: "CartEmpty",
  data() {
    return {}
  },
  methods: {
    coutinueShopping() {
      window.location.href = `${this.MAIN_ORIGIN_HOME}`
    }
  }
}
